// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__9J0lw","cell":"ColumnAccessor_cell__Z5cue","firstCellAccent":"ColumnAccessor_firstCellAccent__1PGYk"};